import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';
import { useProductStore } from './../../../ProductProvider';
import EfSpec from 'elem/ui/ef-spec';
import EfImg from 'elem/ui/ef-img';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useState, useEffect } from 'react';

export default function TheComp() {
    const { t } = useLang('theProduct.ListC');
    const { locale } = useRouter();
    const IS_NA_SITES = ['us', 'ca', 'br', 'mx'].includes(locale);
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);
    const { pageStatus } = useProductStore();
    const [gap, setGap] = useState(20);

    const items = [
        {
            title: t('a_title'),
            desc: t.rich('a_desc', {
                sup: (tx: string) => <sup>{tx}</sup>,
            }),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724577789878/Hassle-free%20connection.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724577789357/Hassle-free%20connection%20(1).jpg',
        },
        {
            title: t('b_title'),
            desc: t.rich('b_desc', {
                sup: (tx: string) => <sup>{tx}</sup>,
            }),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724577789708/USB-C.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724577789523/USB-C%20(1).jpg',
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window.innerWidth > 1440 ? 24 : window.innerWidth > 1024 ? 20 : 16);
        }
    }, []);

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <Swiper className="items" spaceBetween={gap} slidesPerView={'auto'} initialSlide={0}>
                {items?.map((item: any, k: number) => (
                    <SwiperSlide className="item" key={k}>
                        <div className="item-img">
                            <EfImg pc={item.pc} h5={item.h5} />
                        </div>
                        <div className="item-info">
                            <p className="item-title">{item.title}</p>
                            <p className="item-desc">{item.desc}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <EfSpec className="x2" />
        </div>
    );
}
